import { Table } from '@components/primitives/Chart/Table'
import type { DrugNovelUse } from '@modules/drugs/helpers/getTreatmentPageData'

export default function TreatmentNovelUses({
  drugNovelUses,
}: {
  drugNovelUses: DrugNovelUse[]
}) {
  return (
    <Table
      borderClass='border-neutral100'
      headerBackground='bg-neutral50'
      headerRow={['Condition', 'Clinical Trials', 'Trial Phases']}
      rows={[
        ...drugNovelUses.map((item) => [
          item.conditionName,
          `${item.activeTrialCount} Actively Recruiting`,
          item.activeTrialPhaseList.join(', '),
        ]),
      ]}
      textAlignment='text-left'
      textColor='text-neutral500'
    />
  )
}
